import React from 'react';
import logo from '../../icon.png';
import './preflight.css';
import { Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Preflight = () => {
    return (
        <div className="form-page">
            <h1 className='title'>Skriv upp dig i väntelistan!</h1>
            <Form className=''>
                <Form.Group className="mb-3" controlId="formBasicName">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam sagittis purus ac egestas luctus. Nulla fringilla sagittis nunc. Maecenas auctor suscipit lacus, ac vestibulum nunc fermentum et. Maecenas justo nisi, vestibulum eget ultricies et, semper et massa. Vivamus cursus leo eget erat elementum, ut rutrum libero suscipit</p>
                    {/* <Form.Label>Namn</Form.Label> */}
                    <Form.Control type="name" placeholder="Namn" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                    {/* <Form.Label>Email</Form.Label> */}
                    <Form.Control type="email" placeholder="Email" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicQuestion">
                    <Form.Label>Hur hörde du om BokaMatch?</Form.Label>
                    <Form.Control type="question" placeholder="Svar" />
                </Form.Group>
                <Button variant="primary" type="submit">
                    Skicka
                </Button>
            </Form>
        </div>
    );
}

export default Preflight;
